import { httpService } from "@/services/http.service";

const state = {
  reportData: null,
  loading: false,
};

const actions = {
  fetchAnalytics: async ({ commit }, payload) => {
    commit("SET_LOADING", true);
    try {
      const response = await httpService.get("report", {
        params: payload,
      });
      commit("SET_REPORT_DATA", response.data?.data ?? null);
    } catch {
      commit("SET_REPORT_DATA", null);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const mutations = {
  SET_REPORT_DATA: (state, data) => {
    state.reportData = data;
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
